const state = {
  skill: {
    id: 0,
    code: '',
    name_rus: '',
    name_eng: '',
    status_id: 1,
    status: '',
    created_at: new Date(),
    updated_at: new Date(),
    equipment_status: {
      id: 1,
      slug: 'opened',
      name: 'Открыто',
    },
  },
  skills: [],
  eventSkills: [],
  zones: [],
};

export default state;
